/**
 * ========================================
 * KORUNMUŞ ROUTE BİLEŞENİ
 * ========================================
 * Sadece yetkili kullanıcıların erişebileceği route'ları korur
 * Rol bazlı yetkilendirme ve admin panel şifre kontrolü yapar
 */

// ==================== DEPENDENCIES ====================
import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import AdminPasswordCheck from './AdminPasswordCheck';

// ==================== TYPES ====================
interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
  requireAdminPassword?: boolean;
}

// ==================== COMPONENT ====================
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles = ['admin', 'lawyer'],
  requireAdminPassword = false
}) => {
  const [showPasswordCheck, setShowPasswordCheck] = useState(false);
  const userStr = localStorage.getItem('user');
  const token = localStorage.getItem('token');

  // Kimlik doğrulama kontrolü
  if (!token || !userStr) {
    // Kullanıcı giriş yapmamış, login sayfasına yönlendir
    return <Navigate to="/login" replace />;
  }

  try {
    const user = JSON.parse(userStr);

    // Rol adını al (hem eski hem yeni yapıyı destekle)
    const userRole = user.role_name || user.role?.role_name;

    // Rol bazlı yetki kontrolü
    if (allowedRoles && !allowedRoles.includes(userRole)) {
      // Yetkisiz kullanıcı, ana sayfaya yönlendir
      return <Navigate to="/" replace />;
    }

    // Admin panel şifre kontrolü
    if (requireAdminPassword) {
      const hasAdminAccess = sessionStorage.getItem('adminPanelAccess') === 'true';

      if (!hasAdminAccess && !showPasswordCheck) {
        setShowPasswordCheck(true);
      }

      if (showPasswordCheck && !hasAdminAccess) {
        return <AdminPasswordCheck onSuccess={() => setShowPasswordCheck(false)} />;
      }
    }

    return <>{children}</>;
  } catch (error) {
    // Parse hatası, login sayfasına yönlendir
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    return <Navigate to="/login" replace />;
  }
};

// ==================== EXPORT ====================
export default ProtectedRoute;
